import axios from 'axios';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CONFIG } from 'variables/config';
import logo from 'assets/logo.png';
import './GuessAccess.css';

const loadingMessages = [
    'Chargement de votre compte invité',
    'Préparation de votre espace de travail',
    'Configuration de vos accès',
    'Initialisation de votre session',
    'Derniers ajustements en cours'
];

const GuessAccess = () => {
    const params = useParams();
    const [messageIndex, setMessageIndex] = useState(0);

    const handleSubmit = (e: any) => {
        axios
            .post(`${CONFIG.apiUrl}/auth/guest`, { referal: params.id })
            .then((res) => {
                localStorage.setItem('token', res.data.token);
                localStorage.setItem('user-type', 'buyer');
                if (res.data.token.length > 10) {
                   setTimeout(() => {
                    window.location.href = '/';
                    }, 3000);
                }
            })
            .catch(() => {});
    };

    useEffect(() => {
        if (params.id) {
            handleSubmit(params.id);
        }
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setMessageIndex((prev) => (prev + 1) % loadingMessages.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="fixed inset-0 w-screen h-screen flex items-center justify-center z-[9999] bg-gradient-to-br from-[#667eea] to-[#764ba2]">
            <div className="flex flex-col items-center justify-center">
                <div className="relative w-[120px] h-[120px]">

                    <img
                        src={logo}
                        alt="Leadrs Logo"
                        className="w-[240px] h-[240px] object-contain relative z-10"
                        style={{ filter: 'drop-shadow(0 0 20px rgba(255, 255, 255, 0.3))' }}
                    />
                </div>

                <div className="mt-3 h-[60px] flex items-center justify-center">
                    <p
                        key={messageIndex}
                        className="loading-text text-white text-md font-semibold text-center tracking-wide"
                    >
                        {loadingMessages[messageIndex]}
                    </p>
                </div>

                <div className="flex gap-2 mt-1">
                    {[0, 1, 2].map((i) => (
                        <div
                            key={i}
                            className="loading-dot"
                            style={{ animationDelay: `${i * 0.2}s` }}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default GuessAccess;
